import { RouteComponentProps } from 'react-router-dom';

import Request from '../../components/Request';
import LoggedInLayout from '../../components/LoggedInLayout';

export default function RequestPage({
   match,
}: RouteComponentProps<{ id: string }>) {
   const requestId = parseInt(match.params.id);
   return (
      <LoggedInLayout>
         <div className="min-h-screen bg-gray-100">
            <div className="mx-4 py-20 md:py-24">
               <Request requestId={requestId} />
            </div>
         </div>
      </LoggedInLayout>
   );
}
